const WEBLINK_ID = 'weblink-email';
export default WEBLINK_ID;
